import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SearchRequest } from "../../openApiClients/generated/EngineeringUK.Sites";
import { SearchBaseComponent } from "./SearchBaseComponent";
import "./SearchResultsComponent";
import "./SearchFiltersComponent";
import "./SearchBarComponent";

@customElement("euk-search-listing")
export class SearchListingComponent extends SearchBaseComponent {
  @property({ type: String })
  baseUrl?: string;

  @property({ type: Object })
  request?: SearchRequest;

  @property({ type: Boolean })
  enableSearchTerm: boolean = false;

  @property({ type: Boolean })
  showPages: boolean = false;

  constructor() {
    super();
  }

  getSearchContainerCssClasses(): string {
    return "search search--sidebar";
  }

  render() {
    return html`
      ${super.render()}
      ${this.enableSearchTerm
        ? html`
            <euk-search-bar
              .request="${this.request}"
              .stylesheets="${this.stylesheets}"
              .componentid="${this.componentid}"
            ></euk-search-bar>
          `
        : html``}
      <euk-search-filters
        .request="${this.request}"
        .stylesheets="${this.stylesheets}"
        .componentid="${this.componentid}"
      >
        <div slot="filterSlot">
          <slot name="filterSlot"></slot>
        </div>
      </euk-search-filters>
      <div class="${this.getSearchContainerCssClasses()}">
        <euk-search-result
          .baseurl="${this.baseUrl}"
          .request="${this.request}"
          .stylesheets="${this.stylesheets}"
          .componentid="${this.componentid}"
        >
          <div slot="loading">
            <slot name="loading"></slot>
          </div>
          <div slot="beforeResults">
            <slot name="beforeResults"></slot>
          </div>
          <div slot="result">
            <slot name="result"></slot>
          </div>
          <div slot="afterResults">
            <euk-search-pagination
              .baseurl="${this.baseUrl}"
              .request="${this.request}"
              .stylesheets="${this.stylesheets}"
              .componentid="${this.componentid}"
              .showpages="${this.showPages}"
            >
            </euk-search-pagination>
            <slot name="afterResults"></slot>
          </div>
        </euk-search-result>
      </div>
    `;
  }
}
